import React from 'react';
import { motion } from 'framer-motion';
import { Trophy, Check, Shield } from 'lucide-react';
const pack = {
  title: 'PACK COMPLETO',
  subtitle: 'Todo tu año organizado, listo para utilizar.',
  features: ['Los 7 Tomos de Física en Acción', 'Contenidos de 1.º a 6.º año o niveles equivalentes', 'Tomo completo de proyectos y feria de ciencias', 'Los 3 Bonos Estratégicos', 'Bóveda de Evaluación 360', '✅ 40 modelos de evaluaciones para imprimir, con formatos A, B y C', '✅ Rúbricas para trabajos prácticos, proyectos y ferias de ciencias', '✅ Planillas de seguimiento y registro', '✅ Solucionarios para facilitar la corrección', '✅ Acceso a futuras actualizaciones'],
  oldPrice: 'US$39',
  price: 'US$14.99',
  url: 'https://fisica-en-accion-secundaria.impultienda.ar/checkout'
};
export function Pricing() {
  const handlePurchase = () => {
    window.location.href = pack.url;
  };
  return <section id="pricing" className="pt-2 pb-6 md:py-20 px-4 max-w-4xl mx-auto font-sans" data-id="element-140">
      <div className="text-center mb-3 md:mb-16" data-id="element-141">
        <h2 className="text-lg md:text-5xl font-black text-slate-900 mb-0.5" data-id="element-142">
          TU <span className="text-blue-600" data-id="element-143">MEGAPACK</span> FÍSICA EN ACCIÓN™
        </h2>
        <p className="text-slate-600 font-bold text-[9px] md:text-lg" data-id="element-144">
          Todo tu año organizado, listo para utilizar.
        </p>
      </div>

      <div className="mb-3" data-id="element-145">
        <div className="p-4 md:p-8 rounded-xl border-2 border-blue-600 bg-white shadow-lg shadow-blue-900/5 relative overflow-hidden" data-id="element-146">
          <div className="flex items-center justify-between gap-2 mb-1" data-id="element-147">
            <div className="flex items-center gap-1.5" data-id="element-148">
              <Trophy size={18} className="text-blue-600" data-id="element-149" />
              <h3 className="font-black text-slate-900 text-sm md:text-2xl uppercase leading-none" data-id="element-150">
                {pack.title}
              </h3>
            </div>
            <span className="bg-blue-600 text-white text-[8px] md:text-[11px] font-black px-2 py-0.5 rounded-full uppercase tracking-widest" data-id="element-151">
              TODO INCLUIDO
            </span>
          </div>

          <div className="flex items-baseline justify-between mb-2" data-id="element-152">
            <p className="text-slate-500 font-bold text-[10px] md:text-base" data-id="element-153">
              {pack.subtitle}
            </p>
            <div className="flex flex-col items-end" data-id="element-154">
              <div className="flex items-baseline gap-1.5" data-id="element-155">
                <span className="text-slate-400 font-bold text-[10px] md:text-sm uppercase" data-id="element-156">
                  PRECIO REGULAR:
                </span>
                {pack.oldPrice && <span className="text-slate-400 line-through font-bold text-[10px] md:text-lg" data-id="element-157">
                    {pack.oldPrice}
                  </span>}
              </div>
              <div className="flex items-baseline gap-1.5" data-id="element-158">
                <span className="text-slate-900 font-bold text-[10px] md:text-sm uppercase" data-id="element-159">
                  HOY:
                </span>
                <span className="md:text-5xl font-black text-slate-900 text-[28px]" data-id="element-160">
                  {pack.price}
                </span>
              </div>
              <span className="text-slate-500 font-bold text-[8px] md:text-xs mt-1" data-id="element-161">
                Pago único · Sin suscripciones
              </span>
            </div>
          </div>

          <div className="space-y-0.5 border-t border-slate-100 pt-2" data-id="element-162">
            {pack.features.map((f, i) => <div key={i} className="flex items-start gap-1.5 text-[10px] md:text-base text-slate-600 font-medium leading-tight" data-id="element-163">
                {!f.startsWith('✅') && <Check size={12} className="text-blue-600 shrink-0 mt-0.5" data-id="element-164" />}
                <span data-id="element-165">{f}</span>
              </div>)}
          </div>
        </div>
      </div>

      <div className="text-center mb-2" data-id="element-166">
        <div className="bg-[#F0FDF4] border border-green-200 rounded-lg px-3 py-2 mb-3" data-id="element-167">
          <p className="text-[#166534] font-bold text-[11px] md:text-[13px] leading-snug" data-id="element-168">
            📦 <span className="font-black" data-id="element-169">ENTREGA DIGITAL INMEDIATA:</span>{' '}
            Este es un producto digital, por lo que no existen costos de envío.
            Una vez confirmado el pago, recibirás el acceso al material en tu
            correo electrónico.
          </p>
        </div>
      </div>

      <div className="bg-slate-50 border border-slate-200 rounded-xl p-3 md:p-4 mb-4 text-center" data-id="element-170">
        <p className="text-slate-800 font-bold text-[11px] md:text-sm mb-1" data-id="element-171">
          🌎 COMPRA DISPONIBLE EN TODA LATINOAMÉRICA
        </p>
        <p className="text-slate-600 text-[10px] md:text-xs leading-tight" data-id="element-172">
          El precio está expresado en dólares estadounidenses. Si utilizas otra
          moneda, al ingresar al checkout el importe se convertirá
          automáticamente a tu moneda local, según tu país y el medio de pago
          disponible.
        </p>
      </div>

      <motion.button whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} animate={{
      scale: [1, 1.02, 1]
    }} transition={{
      duration: 2,
      repeat: Infinity,
      ease: 'easeInOut'
    }} onClick={handlePurchase} className="w-full bg-[#16A34A] hover:bg-[#15803D] text-white font-black text-lg md:text-3xl py-3.5 rounded-xl shadow-[0_0_20px_rgba(22,163,74,0.4)] mb-1.5 uppercase tracking-tight btn-neon" data-id="element-173">
        QUIERO DESCARGARLO YA!!!
      </motion.button>
      <p className="text-center text-slate-500 text-[10px] md:text-xs font-medium mb-4" data-id="element-174">
        Una vez confirmado el pago, recibirás el acceso al material directamente
        en tu correo electrónico.
      </p>

      <div className="grid grid-cols-3 gap-2 mb-6 max-w-md mx-auto" data-id="element-175">
        {[{
        emoji: '🔒',
        text: 'Pago seguro'
      }, {
        emoji: '⚡',
        text: 'Acceso digital inmediato'
      }, {
        emoji: '🏅',
        text: 'Garantía de satisfacción de 7 días'
      }].map((badge, i) => <div key={i} className="bg-white p-2.5 rounded-xl border border-blue-50 text-center flex flex-col items-center justify-start gap-1" data-id="element-176">
            <span className="text-xl md:text-2xl" data-id="element-177">{badge.emoji}</span>
            <p className="font-bold text-slate-700 text-[9px] md:text-xs leading-tight" data-id="element-178">
              {badge.text}
            </p>
          </div>)}
      </div>

      <div className="bg-white p-4 rounded-2xl border border-blue-100 flex items-center gap-3" data-id="element-179">
        <div className="bg-blue-50 p-2 rounded-lg shrink-0" data-id="element-180">
          <Shield size={20} className="text-blue-600" data-id="element-181" />
        </div>
        <div data-id="element-182">
          <h5 className="text-slate-900 font-black text-[10px] md:text-xl leading-tight" data-id="element-183">
            Garantía de satisfacción 7 días
          </h5>
          <p className="text-slate-500 font-medium text-[9px] md:text-base leading-tight" data-id="element-184">
            Si no te sirve, te devolvemos el 100% de tu dinero.
          </p>
        </div>
      </div>
    </section>;
}